// ============================================================================
// Section 5 — Why teams choose Stravo (6 cards in 3x2 grid)
// ============================================================================

import {
  Smartphone,
  Shield,
  Users,
  ClipboardCheck,
  AlertCircle,
  Zap,
} from "lucide-react";

const CARDS = [
  {
    title: "Cleaner-first design",
    body: "Built around how cleanings actually happen — fast, clear, mobile-first.",
    icon: Smartphone,
  },
  {
    title: "Property-based permissions",
    body: "Team members only access the properties they're invited to.",
    icon: Shield,
  },
  {
    title: "Delegation that scales",
    body: "Owners invite team admins. Team admins add workers and assign tasks.",
    icon: Users,
  },
  {
    title: "Consistent quality",
    body: "Room-by-room checklists + photo requirements keep standards consistent.",
    icon: ClipboardCheck,
  },
  {
    title: "Fewer missed issues",
    body: "Maintenance flags and quick checks catch problems before the next guest.",
    icon: AlertCircle,
  },
  {
    title: "Fast setup",
    body: "Connect a calendar or create tasks manually — start running turnovers immediately.",
    icon: Zap,
  },
];

export default function WhyChooseSection() {
  return (
    <section id="why" className="border-t border-border/60 bg-background py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-6">
        <h2 className="text-center text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-4xl">
          Why teams choose Stravo
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
          {CARDS.map((item) => {
            const Icon = item.icon;
            return (
              <article
                key={item.title}
                className="rounded-xl border border-border/80 bg-card p-6 shadow-sm"
              >
                <div
                  className="mb-3 flex h-9 w-9 items-center justify-center rounded-lg border border-border/80 bg-muted/50 text-foreground"
                  aria-hidden
                >
                  <Icon className="h-4 w-4 stroke-[1.5] text-foreground" />
                </div>
                <h3 className="text-base font-semibold text-foreground">{item.title}</h3>
                <p className="mt-2 text-sm leading-snug text-muted-foreground">{item.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
